import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import resources from './home';

// const language = localStorage.getItem('language');
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    // debug: false,
    ns: ['translations'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    defaultNS: 'translations',
    // returnObjects: true,
    // load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    resources: {
      ...resources,
    },
    // react: {
    //   useSuspense: false,
    //   bindI18n: 'languageChanged loaded',
    //   bindStore: 'added removed',
    //   nsMode: 'default',
    // },
  });

// eslint-disable-next-line import/prefer-default-export
export { i18n as i18nInit };
